// Parsley validation init
$('.js-parsley').length && $('.js-parsley').parsley();

$(document).ready(function () {
	/*
	$.listen('parsley:field:validate', function () {
		validateFront();
	});*/

	$('.js-parsley .btn--submit').on('click', function () {
		$('.js-parsley').parsley().validate();
		validateFront();
	});

	$('.js-close-message').click(function() {
		// Calling a function in case we want to expand upon this.
		hideMessage();
	});

});






/*========================================
=            CUSTOM FUNCTIONS            =
========================================*/
function validateFront() {
	if (true === $('.js-parsley').parsley().isValid()) {
		$('.form-warning-message').addClass('is-hidden');
		//ParsleyField.$element.next('.warning-icon').addClass('hidden');
	} else {
		$('.form-warning-message').removeClass('is-hidden');
		//ParsleyField.$element.next('.warning-icon').removeClass('hidden');
	}
}
function hideMessage() {
  var $message =  $('.form-warning-message');
  $message.addClass('is-hidden');
  $('.js-parsley').parsley().reset();
}
